import React, { useState } from 'react';
import { Box } from '@common-fe/common-fe';

import { Renewal } from '../../../renewals.types';

import { useRenewalFAQData } from './hooks';
import RenewalFAQItem from './RenewalFAQItem';
import RenewalFAQModal from './RenewalFAQModal';

interface Props {
  renewalSetupData?: Renewal;
}

const RenewalFAQ: React.FC<Props> = ({ renewalSetupData }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState<number>(0);
  const rolloverPlans = renewalSetupData?.plans?.filter((plan) => plan.isRollover) || [];

  const faqData = useRenewalFAQData({
    partnerName: renewalSetupData?.partnerName,
    rolloverPlans,
  });

  const handleQuestionClick = (index: number) => {
    setSelectedQuestionIndex(index);
    setIsModalVisible(true);
  };

  return (
    <>
      <Box gap="s" margin={{ bottom: 'spacing24' }} data-testid="renewal-faq-section">
        {faqData.map((item, index) => (
          <RenewalFAQItem
            key={index}
            question={item.question}
            index={index}
            onQuestionClick={() => handleQuestionClick(index)}
          />
        ))}
      </Box>

      <RenewalFAQModal
        visible={isModalVisible}
        selectedQuestionIndex={selectedQuestionIndex}
        onToggleVision={setIsModalVisible}
        faqData={faqData}
      />
    </>
  );
};

export default RenewalFAQ;
